<div class="content text-muted" style="padding-top: 10px; padding-bottom: 10px">
  <h5><strong>Our team is here to help you.</strong></h5>
  <hr />

  <h6><i class="fa fa-phone-square" aria-hidden="true"></i> <strong class="leftspace">Call us: 1.888.365.1777</strong>
  </h6>
  <p class="text-muted">
    <a href="/about/shipping">Shipping</a> | <a href="/about/returns">Returns</a> |
    <a href="/about/privacy/">Privacy</a>
  </p>
  <hr />

  <h6><i class="fa fa-lock" aria-hidden="true"></i> <strong class="leftspace">Shop Secure at Vistek</strong></h6>
  <small class="text-muted">
    All personal information you provide will be confidential and Transactions on Vistek.ca are secure</small>
</div>
